"use client";

import { c as _c } from "react/compiler-runtime";
import { Archive as ArchiveIcon } from "@phosphor-icons/react";
import { TodoList } from "./TodoList";
import { TodoItem } from "@/types";
export interface ArchiveViewProps {
  todos: TodoItem[];
  sortBy: "newest" | "oldest" | "alphabetical" | "completed";
  selectedDate: Date;
  onToggle: (id: string) => void;
  onDelete: (id: string) => void;
  onUnarchive: (id: string) => void;
  onEdit: (id: string, text: string, emoji?: string) => void;
  handleEditTodo: (todo: TodoItem) => void;
  cancelEditing: () => void;
}
export function ArchiveView(t0) {
  const $ = _c(15);
  const {
    todos,
    onToggle,
    onDelete,
    onUnarchive,
    onEdit,
    handleEditTodo,
    cancelEditing
  } = t0;
  const archivedTodos = todos;
  if (archivedTodos.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="flex flex-col items-center justify-center h-[50vh] px-4"><div className="relative mb-6"><div className="w-16 h-16 rounded-full bg-muted/50 border border-border flex items-center justify-center"><ArchiveIcon className="w-8 h-8 text-muted-foreground" /></div></div><h3 className="text-lg font-medium text-foreground mb-1.5">No archived tasks</h3><p className="text-sm text-muted-foreground text-center max-w-[260px]">There are no archived tasks. Deleted tasks will appear here.</p></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const t1 = archivedTodos.length === 1 ? "task" : "tasks";
  let t2;
  if ($[1] !== archivedTodos.length || $[2] !== t1) {
    t2 = <div className="text-sm text-muted-foreground mb-2">Showing {archivedTodos.length} most recent archived {t1}</div>;
    $[1] = archivedTodos.length;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== archivedTodos || $[5] !== cancelEditing || $[6] !== handleEditTodo || $[7] !== onDelete || $[8] !== onEdit || $[9] !== onToggle || $[10] !== onUnarchive) {
    t3 = <TodoList todos={archivedTodos} onToggle={onToggle} onDelete={onDelete} onUnarchive={onUnarchive} onEdit={onEdit} handleEditTodo={handleEditTodo} cancelEditing={cancelEditing} />;
    $[4] = archivedTodos;
    $[5] = cancelEditing;
    $[6] = handleEditTodo;
    $[7] = onDelete;
    $[8] = onEdit;
    $[9] = onToggle;
    $[10] = onUnarchive;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className="space-y-2">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}